import Vue from 'vue'
import Rollbar from 'vue-rollbar'

if (['staging', 'production'].includes(process.env.VUE_APP_MODE)) {
  Vue.config.errorHandler = function(err) {
    Vue.rollbar.error(err)
  }
}
